import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import ElementUI from 'element-ui';
import ELeMultiCascader from 'ele-multi-cascader';
import globalComponents from './components/index';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import echarts from 'echarts'
import VCharts from 'v-charts'
import BaiduMap from 'vue-baidu-map'
import "./assets/iconfont/iconfont.css";
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import '../static/css/theme-green/index.css';       // 浅绿色主题
import './assets/css/icon.css'
import './components/common/directives';
import "babel-polyfill";
import prompts from './utils/prompts'
import Vuex from 'vuex';
import store from "@/store";
import bus from '../src/components/common/bus';
import "../theme/index.css";
import './assets/style_second/style.css'
import 'swiper/dist/css/swiper.css'
// import Router from 'vue-router'
// 数组内元素相加方法
import sumOfArray from './utils/sumOfArray';
import currencyInput from "./components/input/currencyInput";
import accounting from 'accounting'

import "./utils/sync-bid";
import './directives';

import 'xe-utils';
// import Vue from 'vue';
import hljs from 'highlight.js';
import 'vxe-table/lib/index.css';
import VXETable from 'vxe-table';
import XEUtils from 'xe-utils';
import VXEUtils from 'vxe-utils';

Vue.prototype.Array = sumOfArray

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
Vue.use(currencyInput)
Vue.use(VCharts)
Vue.use(BaiduMap, {
  ak: 'mYgtC22fxvpD5t2rhnCKK9Mt78ItHjvP'
})
Vue.prototype.$echarts = echarts
Vue.use(VueAwesomeSwiper)
Vue.use(Vuex)
Vue.use(ELeMultiCascader);
Vue.use(globalComponents)
Vue.use(VXETable);
Vue.use(VXEUtils,XEUtils);
Vue.config.productionTip = false;
Vue.prototype.$prompts = prompts
Vue.use(ElementUI, {
  size: 'small'
});

import uploader from 'vue-simple-uploader'
Vue.use(uploader)
//axios.defaults.baseURL = "http://192.168.1.31:9095/bop"   //服务器ip地址
// axios.defaults.baseURL = "http://192.168.1.12:9095/bop"   //ip地址
import '../static/style.css'
axios.defaults.baseURL = '/bohee/';
Vue.prototype.$http = axios;

import api from "./api/api-config";
Vue.prototype.api = api;

Vue.config.productionTip = false;

axios.interceptors.request.use(
  config => {
    // 这里写死一个token，你需要在这里取到你设置好的token的值
    const token = sessionStorage.getItem("Token")
    if (token) {
      // 这里将tokexn设置到headers中，header的key是Authorization，这个key值根据你的需要进行修改即可
      config.headers.Authorization = token
      config.headers.Auth = "1"
    }
    axios.defaults.headers.common['Authorization'] = token //调用退出接口手动携带请求头
    axios.defaults.headers.common['Auth'] = "1" //调用退出接口手动携带请求头
    return config
  },
  error => {
    return Promise.reject(error)
  });

let noisyTimerId;
function isNoisy(config) {
  return !config.url.endsWith('-quietly');
}
/**
 *
 * @param {*} param0 { config: { url: 'xxx' } }
 * @param {*} isShow 是否显示Loading遮罩层
 */
function dealNoise({ config }, isShow) {
  if (isNoisy(config)) {
    clearTimeout(noisyTimerId);
    noisyTimerId = null;

    // prevent flash loading
    // 尽量避免加载抖动
    const thatTimerId = setTimeout(() => {
      if (thatTimerId === noisyTimerId) {
        bus.$emit('isShow', isShow);
        noisyTimerId = null;
      }
    }, isShow ? 300 : 1200);
    noisyTimerId = thatTimerId;
  }
}

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  store.commit('url', config.url);
  dealNoise({ config }, true);
  bus.$emit('boheeUrl', axios.defaults.baseURL)
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  const config = response.config;
  dealNoise({ config }, false);
  bus.$on('isPaths', msg => {})
  bus.$emit('boheeUrl', axios.defaults.baseURL)

  return response
}, function (error) {
  if (error) {
    const config = error.config;
    isNoisy(config) && store.commit('Status', false);
    dealNoise({ config }, false);
  }
  return Promise.reject(error)
});

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  // const role = sessionStorage.getItem('ms_username');
  const token = sessionStorage.getItem('Token')
  if (!token && to.path !== '/login') {
    next('/login')

  } else if (to.meta.permission) {
    // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    // role === 'admin' ? next() : next('/403');
    next()
  } else {
    // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
    if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
      Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
        confirmButtonText: '确定'
      });
    } else {
      next();
    }
  }
})
// export default function(to,from,next){

// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js